import React from 'react';
import { Grid } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/collections/grid.less';

export default Grid;
